import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LINKS } from "@/lib/site";

const PHONE_TABS = {
  community: {
    label: "Community",
    img: "/jgw-community.png",
    alt: "JGW WhatsApp Community",
    title: "Join the JGW Community",
    cta: "Click Here to Join",
    href: LINKS.community,
    testId: "phone-cta-join-button",
  },
  status: {
    label: "Status",
    img: "/jgw-status.png",
    alt: "JGW WhatsApp Status",
    title: "Get JGW Updates on Status",
    cta: "Click Here to Subscribe",
    href: LINKS.status,
    testId: "phone-cta-subscribe-button",
  },
};

const PhoneMockup = () => {
  const [tab, setTab] = useState("community");
  const cfg = PHONE_TABS[tab];

  return (
    <div className="mx-auto w-full max-w-[300px] lg:max-w-[330px]" data-testid="phone-mockup">
      <div
        className="mb-3 grid grid-cols-2 gap-1 rounded-full border border-white/15 bg-black/70 p-1 backdrop-blur"
        role="tablist"
      >
        {Object.entries(PHONE_TABS).map(([key, t]) => (
          <button
            key={key}
            type="button"
            role="tab"
            aria-selected={tab === key}
            data-testid={`phone-tab-${key}`}
            onClick={() => setTab(key)}
            className={`rounded-full py-2.5 text-xs font-bold uppercase tracking-[0.15em] transition-colors duration-200 ${
              tab === key ? "bg-white text-black" : "text-silver hover:text-white"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="animate-float">
        <div className="rounded-[2.6rem] border border-white/15 bg-black/80 p-2 shadow-[0_40px_90px_-20px_rgba(0,0,0,0.85)] backdrop-blur">
          <div className="relative aspect-[706/1536] overflow-hidden rounded-[2.05rem] bg-[#0B141A]">
            <AnimatePresence mode="wait" initial={false}>
              <motion.img
                key={tab}
                src={cfg.img}
                alt={cfg.alt}
                data-testid="phone-screenshot"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.25, ease: "easeOut" }}
                className="absolute inset-0 h-full w-full object-cover object-top"
                draggable={false}
              />
            </AnimatePresence>
          </div>
        </div>

        <div className="relative z-10 mx-3 -mt-2 rounded-2xl border border-white/10 bg-charcoal-800 p-4 shadow-2xl">
          <p className="text-center text-sm font-bold text-white" data-testid="phone-cta-title">
            {cfg.title}
          </p>
          <a
            href={cfg.href}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={cfg.testId}
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-xl bg-whatsapp py-3.5 text-sm font-bold text-white transition-colors duration-200 hover:bg-whatsapp-dark"
          >
            <MessageCircle size={17} strokeWidth={2.2} />
            {cfg.cta}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PhoneMockup;
